<i
  (click)="deleteFile()"
  style="cursor: pointer"
  class="fa {{ icon }} text-danger ml-2"
  [ngClass]="{ disabled: disabled }"
></i>
